import { RefObject, useLayoutEffect, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import MapViewProperties = __esri.MapViewProperties;

/**
 * React hook that creates an ArcGIS MapView instance inside a provided DOM ref when the options map is available, and calls an optional callback when the view fully loads.
 *
 * @param ref - React ref to the DOM element where the MapView will be mounted.
 * @param options - MapViewProperties options object spread into the MapView constructor.
 * @param callback - Optional callback invoked with the fully loaded MapView instance.
 * @returns The MapView instance, or undefined until it loads.
 */
export const useMapView = (ref: RefObject<any>, options: MapViewProperties, callback?: (view: MapView) => void) => {
  const [view, setView] = useState<MapView>();
  useLayoutEffect(() => {
    if (ref && ref.current && !view && options.map) {
      const opts: MapViewProperties = {
        container: ref.current,
        ...options
      };
      const newView = new MapView(opts);
      setView(newView);
      newView.when((v: MapView) => {
        if (callback) callback(v);
      }).catch((reason: unknown) => {
        console.error({ reason });
      });
    }
  }, [ref, view, options]);
  return view;
};

